import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e2a6f4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "project-slider" }
const _hoisted_2 = { class: "top-cont" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "swiper-container" }
const _hoisted_5 = { class: "swiper-wrapper" }
const _hoisted_6 = ["href"]
const _hoisted_7 = {
  class: "abs-img",
  alt: "Project Image"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))

import Swiper from 'swiper';
import { onMounted, ref } from 'vue';
import { store } from '@/store/store';
import {comercialProjectModel} from '../models/comercialProjectsModel'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectSlider',
  props: {
    title: {},
    data: {}
  },
  setup(__props: any) {

const props = __props;

const Store = store();

const mySwiper = ref();

const initSwiper = (): void => {
    mySwiper.value = new Swiper('.project-slider .swiper-container', {
        // Configure Swiper options here
        slidesPerView: 3.2,
        spaceBetween: 27,
        speed: 800,
        watchOverflow: true,
        resizeObserver: true,
        breakpoints: {
            320: {
                slidesPerView: 1.2,
                spaceBetween: 15
            },
            767: {
                slidesPerView: 2.2,
                spaceBetween: 20
            },
            1023: {
                slidesPerView: 3.2,
                spaceBetween: 27,
            }
        }
    });
    mySwiper.value.init();
    mySwiper.value.on('sliderMove', () => {
        Store.setActiveMouse(false)
    })
}

onMounted(() => {
    initSwiper();
})

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(props.title), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "swiper-slide",
            key: index
          }, [
            _createElementVNode("a", {
              href: item.link,
              target: "__blank"
            }, [
              _createElementVNode("div", {
                class: "box",
                onMouseenter: _cache[0] || (_cache[0] = ($event: any) => (_unref(Store).setActiveMouse(true))),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (_unref(Store).setActiveMouse(false)))
              }, [
                _withDirectives(_createElementVNode("img", _hoisted_7, null, 512), [
                  [_directive_lazy, { src: item.img, loading: require('@/assets/loading.gif')}]
                ]),
                _hoisted_8,
                _createElementVNode("p", null, _toDisplayString(item.name), 1)
              ], 32)
            ], 8, _hoisted_6)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})